import React, { useState } from "react";
import { TextField, Popper, Paper, InputAdornment } from "@mui/material";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { ar } from "date-fns/locale";
import { Calendar2 } from "react-bootstrap-icons";

export default function DateRangePickerArabic({range, handleSelect}) {
  const [anchorEl, setAnchorEl] = useState(null);



  // Format date for Arabic locale
  const formatDate = (date) => date?.toLocaleDateString("ar-EG");

  return (
    <div dir="rtl">
      <TextField
        sx={{ minWidth: "160px", width: { xs: "100%", sm: "260px" } }}
        label="اختر فترة تاريخ"
        value={
          range?.from && range?.to
            ? `${formatDate(range.from)} - ${formatDate(range.to)}`
            : ""
        }
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Calendar2 />
              </InputAdornment>
            ),
          },
        }}
        onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}
        readOnly
      />

      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom-start"
      >
        <Paper elevation={3} sx={{ p: 2 }}>
          <DayPicker
            mode="range"
            dir="rtl"
            selected={range}
            onSelect={handleSelect}
            locale={ar}
          />
        </Paper>
      </Popper>
    </div>
  );
}
